import React from 'react';
import counterpart from 'counterpart';
import './Nav.scss';
import history from '../../utils/history';

import Tooltip from '../../components/ui/tooltip/Tooltip';
import logo from '../../images/billsby-logo.svg';
import NavItem from './NavItem';
import ReactTooltip from 'react-tooltip';
import { IAuthReducerState } from '../../reducers/authReducer';
import { INavItems, INavItem } from '../../models/Nav';
import { logout } from '../../utils/authUtils';
import { connect } from 'react-redux';
import { AppState } from '../..';
import { ConfigConstants } from '../../utils/config';


const DEFAULT_NAV_ITEMS: INavItems = {
  users: {
    targets: ["/users"]
  },
  intercom: {
    targets: ["/intercom"]
  },
  companies: {
    targets: ["/companies"]
  },
  freeTrials: {
    targets: ["/free-trials"]
  },
  changeCard: {
    targets: ["/change-card"]
  },
  changeBillingDate: {
    targets: ["/change-billing-date"]
  },
  changeCancellationDate: {
    targets: ["/change-cancellation-date"]
  },
  spreedlyPaymentLogs: {
    targets: ["/spreedly-payment-logs"]
  },
  paymentLogs: {
    targets: ["/payment-logs"]
  }
}

interface INavProps {
  authData: IAuthReducerState,
  navItems?: Partial<INavItems>
}

interface INavState {
  billingModal: boolean,
  sandboxModal: boolean,
  editProfileModal: boolean,
  addCompanyModal: boolean,
  changePasswordModal: boolean,
  [x: string]: any
}

interface IFooterTooltipItem {
  icon: string,
  content: string,
  onClick?: any,
  isEnabled?: boolean
}

interface IFooterTooltipItemSupportCode {
  icon: string,
  content: string,
  code: string
}

const FooterTooltipItem = (props: IFooterTooltipItem) => {
  const { icon, content, onClick = () => { }, isEnabled = true } = props;
  if (!isEnabled) {
    return null;

  }
  return (
    <li onClick={() => { isEnabled && onClick() && ReactTooltip.hide() }}>
      <button>
        <i className={icon} />
        <span>{counterpart(content)}</span>
      </button>
    </li>
  )
}

const FooterTooltipItemSupportCode = (props: IFooterTooltipItemSupportCode) => {
  const { icon, content, code } = props;
  return (
    <div className="navbar__content-footer__tip-plaintext">
      <i className={icon} />
      <span>{counterpart(content)} <span className="navbar__content-footer__tip-plaintext-code">{code}</span></span>
    </div>
  )
}

class Nav extends React.Component<INavProps, INavState> {
  state: INavState = {
    billingModal: false,
    sandboxModal: false,
    editProfileModal: false,
    addCompanyModal: false,
    changePasswordModal: false,
  }

  goTo = (url: string) => {
    history.push(url);
  }

  openInNewTab = (url: string) => {
    const win = window.open(url, '_blank');
    if (win != null)
      win.focus();
  }

  openCloseModal = (name: string) => {
    this.setState({ [name]: !this.state[name] });
  }

  /* expand only one menu at a time */
  setIsMenuItemxEpanded = (menuItemKey: string, isExpanded: boolean) => {
    const menuItems = { ...DEFAULT_NAV_ITEMS, ...this.props.navItems };
    const newMenuItems: any = { ...menuItems };
    newMenuItems[menuItemKey].isExpanded = isExpanded;

    Object.keys(newMenuItems)
      .forEach(key => {
        const menuItem = (newMenuItems as any)[key] as INavItem;
        if (key !== menuItemKey && menuItem.targets.every((target: string) => history.location.pathname.indexOf(target) < 0)) {
          newMenuItems[key].isExpanded = false;
        }
      });

    this.setState({ menuItems: newMenuItems });
  }


  render() {
    const { authData } = this.props;
    const { parsedToken } = authData;
    const menuItems = { ...DEFAULT_NAV_ITEMS, ...this.props.navItems };
    const { users, intercom, companies, freeTrials, changeCard, changeBillingDate, spreedlyPaymentLogs, paymentLogs, changeCancellationDate } = menuItems;
    const isProd = ConfigConstants.reactAppEnvironment === "Production"

    if (!parsedToken) {
      return null;
    }

    return (
      <div className="navbar" >
        <div className="navbar__logo">
          <img src={logo} alt="Billsby Logo" />
        </div>
        <div className="navbar__content">
          <div className="navbar__content-body">
            <NavItem
              icon="fas fa-user-friends"
              content="NAVBAR_USERS"
              targets={users.targets}
              id="link-users"
            />

            <NavItem
              icon="fas fa-building"
              content="NAVBAR_COMPANIES"
              targets={companies.targets}
              id="companies"
            />

            <NavItem
              icon="fab fa-intercom"
              content="NAVBAR_INTERCOM"
              targets={intercom.targets}
              id="link-users"
            />

            {/* <NavItem
              icon="fas fa-building"
              content="NAVBAR_FREE_TRIALS"
              targets={freeTrials.targets}
              id="free-trials"
            /> */}

            {!isProd && <NavItem
              icon="fas fa-credit-card"
              content="NAVBAR_CHANGE_CARD"
              targets={changeCard.targets}
              id="change-card"
            />}
            {/*<NavItem
              icon="fas fa-calendar-alt"
              content="NAVBAR_CHANGE_BILLING_DATE"
              targets={changeBillingDate.targets}
              id="change-billing-date"
            />*/}

            <NavItem
              icon="fas fa-calendar-alt"
              content="NAVBAR_CHANGE_CANCELLATION_DATE"
              targets={changeCancellationDate.targets}
              id="change-billing-date"
            />

            {/*<NavItem
              icon="fas fa-file"
              content="NAVBAR_SPREEDLY_PAYMENT_LOGS"
              targets={spreedlyPaymentLogs.targets}
              id="spreedly-payment-logs"
            />*/}

            <NavItem
              icon="fas fa-calendar-alt"
              content="NAVBAR_PAYMENT_LOGS"
              targets={paymentLogs.targets}
              id="payment-logs"
            />
          </div>

          <div className="navbar__content-footer">
            <NavItem
              icon="fas fa-user"
              className=""
              content={parsedToken.given_name}
              shouldTranslate={false}
              dataFor="show-docs"
            />
            <Tooltip id="show-docs" place="top">
              <ul className="navbar__content-footer__tip">

                <FooterTooltipItem
                  onClick={logout}
                  icon="fas fa-sign-out-alt"
                  content="NAVBAR_LOGOUT"
                />
              </ul>
            </Tooltip>

          </div>

        </div>

      </div>
    )
  }
}

export default connect((state: AppState) => ({ authData: state.auth }))(Nav);